module.exports = __webpack_public_path__ + "resources/img/img-secuve-tos-03-jp.55f1d92ef009b240e8e4a73cb0f76ba3.png";